import script from "./MyPayments.vue?vue&type=script&setup=true&lang=js"
export * from "./MyPayments.vue?vue&type=script&setup=true&lang=js"

import "./MyPayments.vue?vue&type=style&index=0&id=1058890c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1058890c"]])

export default __exports__